<template>
  <div>
    <div class="text-xl font-bold text-text leading-tight mb-8">{{ $t('listTitle') }}</div>
    <template v-if="list.length > 0">
      <div v-for="(item,i) in list" :key="i"
           class="flex items-center rounded pl-6 lg:pl-8 pr-4 py-4
                bg-block hover:bg-bg group even:bg-bg
                transition duration-200 -mx-2 lg:-mx-6">

        <div class="text-text-secondary text-sm w-78 mr-20">{{ item.title }}</div>
        <div class="text-text-secondary text-sm mr-auto -ml-0-5">{{ getType(item.type) }}</div>
        <div v-if="!currentUserIsWatcher"
             class="mr-4"
             @click="$emit('edit',item)">
          <IconEdit class="opacity-0 group-hover:opacity-100
                         transition duration-200 cursor-pointer
                         text-icon hover:text-icon-hover"/>
        </div>
      </div>
    </template>
    <div v-else class="text-md pl-2 text-text">
      {{ $t('noIncomeSources') }}
    </div>
  </div>

</template>

<script>
import IconEdit from "@/components/icons/IconEdit";
import {mapGetters} from "vuex";

export default {
  name: "ContractorsList",
  components: {IconEdit},
  data() {
    return {
      types_list: [
        {id: 1, title: this.$t('typeIncome')},
        {id: 2, title: this.$t('typeExpense')},
        {id: 3, title: this.$t('typeUniversal')}
      ]
    }
  },
  props: {
    list: {
      type: Array,
      default: []
    }
  },
  computed: {
    ...mapGetters('space', ['currentUserIsWatcher'])
  },
  methods: {
    getType(id) {
      return this.types_list.filter(i => i.id === id)[0].title;
    }
  },
  i18n: {
    messages: {
      en: {
        listTitle: 'List of your contractors',
        typeIncome: 'Income',
        typeExpense: 'Expense',
        typeUniversal: 'Universal',
        noIncomeSources: 'You haven\'t created any contractors'
      },
      ru: {
        listTitle: 'Список ваших контрагентов',
        typeIncome: 'Доходный',
        typeExpense: 'Расходный',
        typeUniversal: 'Универсальный',
        noIncomeSources: 'У вас еще нет контрагентов'
      }
    }
  }
}
</script>

<style scoped>

</style>
